var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationAct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_864_263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 0.0424805C9.3535 0.0453916 6.81663 1.09776 4.94549 2.96871C3.07435 4.83966 2.02173 7.37642 2.01855 10.0225C2.01855 12.5925 4.00855 16.6145 7.93355 21.9765C8.40081 22.6166 9.01261 23.1374 9.71916 23.4964C10.4257 23.8554 11.207 24.0425 11.9996 24.0425C12.7921 24.0425 13.5734 23.8554 14.28 23.4964C14.9865 23.1374 15.5983 22.6166 16.0656 21.9765C19.9906 16.6145 21.9806 12.5925 21.9806 10.0225C21.9774 7.37642 20.9248 4.83966 19.0536 2.96871C17.1825 1.09776 14.6456 0.0453916 11.9996 0.0424805ZM11.9996 14.0005C11.2084 14.0005 10.4351 13.7659 9.77727 13.3264C9.11948 12.8868 8.60679 12.2621 8.30404 11.5312C8.00129 10.8003 7.92207 9.99605 8.07641 9.22012C8.23075 8.4442 8.61172 7.73146 9.17113 7.17205C9.73054 6.61264 10.4433 6.23168 11.2192 6.07734C11.9951 5.923 12.7994 6.00221 13.5303 6.30496C14.2612 6.60771 14.8859 7.1204 15.3254 7.7782C15.765 8.436 15.9996 9.20936 15.9996 10.0005C15.9996 11.0613 15.5781 12.0788 14.828 12.8289C14.0778 13.5791 13.0604 14.0005 11.9996 14.0005Z",
    fill: "#7161BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_864_263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationAct);
export default __webpack_public_path__ + "static/media/locationAct.938b3d64e1c756b2331b3a090bc006f8.svg";
export { ForwardRef as ReactComponent };